/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


  // Improve File Upload Display
  $("#input_2_9").change(function(){
    filename = $(this).val();
    filename = filename.replace('C:\\fakepath\\', '');
    $('#up-custom').attr('data-content',filename);
  });

  function openFileDialog() {
    $('#input_2_9').click();
  }

  $(document).ready(function() {
    $("#gform_2").on( "click", "#field_2_9", function() {
      setTimeout(openFileDialog,1);
    });
  });


  // Allow HTML break on slashes in table
  $(".flextable td").each(function() {
    var text = $(this).text();
    text = text.replace(/\//ig, '/<wbr>');
    $(this).html(text);
  });


  // Dirty, dirty browser targeting
  var layoutEngine=(function(){var html=document.documentElement,style=html.style,vendor=" vendor-",edge="edge",ie="ie",khtml="khtml",mozilla="mozilla",opera="opera",webkit="webkit",browser=" browser-",android="android",chrome="chrome",safari="safari",iosSafari=safari+"-ios",wiiu="wiiu",cssClass=vendor,jsObject;if("msScrollLimit" in style||"behavior" in style){if("msTextSizeAdjust" in style){cssClass+=edge;jsObject={vendor:edge};}else{cssClass+=ie+vendor+ie;jsObject={vendor:ie};if("msImeAlign" in style){cssClass+="-11";jsObject.version=11;}else{if("msUserSelect" in style){cssClass+="-10";jsObject.version=10;}else{if("fill" in style){cssClass+="-9";jsObject.version=9;}else{if("widows" in style){cssClass+="-8";jsObject.version=8;}else{cssClass+="-7";jsObject.version=7;}}}}}}else{if("WebkitAppearance" in style){cssClass+=webkit;var ua=navigator.userAgent;jsObject={vendor:webkit};if(!!window.chrome||ua.indexOf("OPR")>=0||ua.indexOf("wv")>=0){cssClass+=browser+chrome;jsObject.browser=chrome;}else{if("webkitDashboardRegion" in style){cssClass+=browser+safari;jsObject.browser=safari;}else{if("webkitOverflowScrolling" in style){cssClass+=browser+iosSafari;jsObject.browser=iosSafari;}else{if(ua.indexOf("Android")>=0){cssClass+=browser+android;jsObject.browser=android;}else{if(!!window.wiiu){cssClass+=browser+wiiu;jsObject.browser=wiiu;}}}}}}else{if("MozAppearance" in style){cssClass+=mozilla;jsObject={vendor:mozilla};}else{if("OLink" in style||!!window.opera){cssClass+=opera;jsObject={vendor:opera,};if("OMiniFold" in style){cssClass+="-mini";jsObject.browser="mini";}}else{if("KhtmlUserInput" in style){cssClass+=khtml;jsObject={vendor:khtml};}else{return false;}}}}}html.className+=cssClass;return jsObject;})();


  // jQuery Actual Height plugin
  (function(a){if(typeof define==="function"&&define.amd){define(["jquery"],a);
  }else{a(jQuery);}}(function(a){a.fn.addBack=a.fn.addBack||a.fn.andSelf;a.fn.extend({actual:function(b,l){if(!this[b]){throw'$.actual => The jQuery method "'+b+'" you called does not exist';
  }var f={absolute:false,clone:false,includeMargin:false,display:"block"};var i=a.extend(f,l);var e=this.eq(0);var h,j;if(i.clone===true){h=function(){var m="position: absolute !important; top: -1000 !important; ";
  e=e.clone().attr("style",m).appendTo("body");};j=function(){e.remove();};}else{var g=[];var d="";var c;h=function(){c=e.parents().addBack().filter(":hidden");
  d+="visibility: hidden !important; display: "+i.display+" !important; ";if(i.absolute===true){d+="position: absolute !important; ";}c.each(function(){var m=a(this);
  var n=m.attr("style");g.push(n);m.attr("style",n?n+";"+d:d);});};j=function(){c.each(function(m){var o=a(this);var n=g[m];if(n===undefined){o.removeAttr("style");
  }else{o.attr("style",n);}});};}h();var k=/(outer)/.test(b)?e[b](i.includeMargin):e[b]();j();return k;}});}));


  // Normalize Carousel Heights - pass in Bootstrap Carousel items.
  function carouselNormalization() {
    var items   = $('#carousel .carousel-item'),
        heights = [],
        tallest;

    function normalizeHeights() {
      items.each(function() {
        heights.push($(this).actual('height'));
      });

      tallest = Math.max.apply(null, heights);

      items.each(function() {
        topad = ( tallest - $(this).actual('height') ) / 4;
        $(this).css('min-height', tallest + 'px');
        $(this).css('padding-top', topad + 'px');
        $(this).find('.slide-img').css('padding-bottom', topad + 'px');
      });
    }

    if (items.length) {
      normalizeHeights();

      $(window).on('resize orientationchange', function() {
        tallest = 0;
        heights.length = 0;

        items.each(function() {
          $(this).css('min-height', '0');
        });

        normalizeHeights();
      });
    }
  }

  $('document').ready(function() {

    carouselNormalization();

    $("#carousel").on( "click", "#playpause.pause", function() {
      $('#carousel').carousel('pause');
      $(this).addClass('play').removeClass('pause');
    });

    $("#carousel").on( "click", "#playpause.play", function() {
      $('#carousel').carousel('cycle');
      $(this).addClass('pause').removeClass('play');
    });

    if ( $('#carousel').length ) {
      var carouselhammer = document.getElementById('carousel');
      var hammertime = new Hammer(carouselhammer);
      hammertime.on('swipeleft', function(){
        $('#carousel').carousel('next');
      });
      hammertime.on('swiperight', function(){
        $('#carousel').carousel('prev');
      });
    }

  });


  // Detect touch devices
  /* jshint ignore:start */
  !function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase(),h=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=h;var m=d.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",h.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");m(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var v=0;v<Modernizr._q.length;v++)Modernizr._q[v]();e.Modernizr=Modernizr}(window,document);!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase(),h=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=h;var m=d.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",h.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");m(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var v=0;v<Modernizr._q.length;v++)Modernizr._q[v]();e.Modernizr=Modernizr}(window,document);
  /* jshint ignore:end */


  // Expertise & Capabilities UI
  function checkSize(){
    if ($(".child-tabs .exp-nav").css("display") !== "none" ){

      $('body').scrollspy({ 'target': '#nav-scrollspy' });

      var navbar = $('#nav-pills-fixed'),
        distance = navbar.offset().top,
        $window = $(window);

      $window.scroll(function() {
        if ($window.scrollTop() >= distance) {
          navbar.removeClass('navbar-fixed-top').addClass('navbar-fixed-top');
          $("#nav-scroller .exp-tab").addClass('navbar-padded-top');
          $("#nav-scroller .exp-tab > .exp-tab-pane").removeClass('active');
          var currentSection = $("#nav-pills-fixed a.active").data("anchor");
          //$('#' + currentSection).addClass('active');
          //activeTabOffset = $("#nav-scroller .exp-tab > .exp-tab-pane.active")[0].getBoundingClientRect();
          //if ( activeTabOffset.top < 1 ) {
          //  $("#nav-scroller .exp-tab").addClass('navbar-padded-top');
          //}
        } else {
          navbar.removeClass('navbar-fixed-top');
          $("#nav-scroller .exp-tab").removeClass('navbar-padded-top');
          $('.exp-nav li:first-child a').tab('show');
        }
      });

    }
  }

  $(document).ready(function($) {
    if ( $('body').hasClass('expertise') || $('body').hasClass('capabilities') ) {
      checkSize();
      $(window).resize(checkSize);
    }
    $('.exp-nav-link').click(function(e){
      $('#nav-pills-fixed').addClass('navbar-fixed-top');
      $("#nav-scroller .exp-tab").addClass('navbar-padded-top');
      $(".active").removeClass('active');
      newActive = $(this).data("anchor");
      $(this).addClass('active');
      //$('#' + newActive).addClass('active');
      return true;
    });
  });

})(jQuery); // Fully reference jQuery after this point.
